module.exports = __webpack_public_path__ + "img/hr-assembling-machine-2-pipe-S.6e35a502.png";